import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "pop-up",
  ref: "popUp"
}
const _hoisted_3 = { class: "top-block" }
const _hoisted_4 = { class: "game-name" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.getVisibleInPopUp)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "game-bg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.btnclose && _ctx.btnclose(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getGameInPopUp), 1),
            _createElementVNode("div", {
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.btnclose && _ctx.btnclose(...args)))
            }, "X")
          ]),
          (_ctx.getUrlInPopUp)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: _ctx.getUrlInPopUp,
                sandbox: "allow-scripts allow-same-origin",
                allow: "autoplay"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ], 512)
      ]))
    : _createCommentVNode("", true)
}